import { datadogRum } from "@datadog/browser-rum";
import { sha256 } from "../../src/networking/security";
import * as segmentFunctions from "./segment/constants/segmentFunctions";
const segmentActive = true;

export const identifyUser = async (nerveId, userData) => {
    const hashNerveId = nerveId ? sha256(nerveId) : false;
    const hash = hashNerveId;
    if (segmentActive) {
        segmentFunctions.identifyUser(hash, userData);
    }
};

export const pushEventGlobally = (event_name, event_properties) => {
    // Send event to segment if MP event push status is active
    if (segmentActive) {
        segmentFunctions.trackEvent(event_name, event_properties);
    }
    // Other Functions
};

export const identifyGroup = async (nerveId, userData) => {
    const hashNerveId = nerveId ? sha256(nerveId) : false;
    const hash = hashNerveId;
    if (segmentActive) {
        segmentFunctions.identifyGroup(hash, userData);
    }
};

export const pushPageCall = (event_name, event_properties) => {
    // Send event to segment if MP event push status is active
    if (segmentActive) {
        segmentFunctions.trackPage(event_name, event_properties);
    }
    // Other Functions
};

export const reset = () => {
    if (segmentActive) {
        segmentFunctions.reset();
    }
};

export const intializeDatadog = () => {
	/* Initializing the datadogRum object. */
    datadogRum.init({
        applicationId: `${process.env.REACT_APP_DATADOG_APP_ID}`,
        clientToken: `${process.env.REACT_APP_DATADOG_CLIENT_TOKEN}`,
        site: "datadoghq.com",
        service: "k4b-web-app",
        // Specify a version number to identify the deployed version of your application in Datadog
        version: `${process.env.REACT_APP_VERSION}`,
        env: `${process.env.REACT_APP_DATADOG_TAG}`,
        sampleRate: 20,
        premiumSampleRate: 50,
        trackInteractions: true,
        defaultPrivacyLevel: "mask-user-input",
    });
    datadogRum.startSessionReplayRecording();
};
